<template>
    <div class="wtw-container size-option-container clearfix">
        <div class="flex-grid flex-grid-column">
            <div
                class="select-wrapper"
                :class="{ 'select-wrapper--value-selected': optionValues[index], [`select-wrapper--${option.product_option_token}`]: true }"
                v-for="(option, index) in optionsAll"
                :key="option.product_option_id"
            >
                <label class="size-label" :for="`size-${option.product_option_id}`">
                    {{option.product_option_title}}
                    <span class="size-select-value">{{optionValueTitles[index]}}</span>
                    <select
                        :name="option.product_option_title"
                        :id="`size-${option.product_option_id}`"
                        v-model="optionValues[index]"
                        @change="sizeChanged($event, option, index)"
                        class="size-select"
                    >
                        <option :value="null">Select a size</option>
                        <option v-for="optionValue in option.product_option_values"
                                :key="optionValue.product_option_value_id"
                                :value="optionValue.product_option_value_id">
                            {{ optionValue.product_option_value_title }}
                        </option>
                    </select>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import Mixins from'../../../mixins/mixins.js';

    export default{
        data() {
            return {
                optionValues: [],
                selectedOptionValues: [],
                optionValueTitles: []
            }
        },
        mixins: [Mixins],
        props: ['options', 'sendOptions', 'optionsAll', 'optionsSelected'],
        computed: {
            
        },
        methods: {
            optionValueTitle(index) {
                return this.optionsAll[index] && this.optionValues[index] && this.optionsAll[index].find(option => option.product_option_value_id === this.optionValues[index]).product_option_value_title;
            },
            focusSelect(token) {
                console.log(this.$refs[token]);
                this.$refs[token][0].click();
            },
            printOptionValues(){
                console.log(this.optionValues);
            },
            sizeChanged(event, option, index) {
                const optionSelected = option.product_option_values.find(option => option.product_option_value_id === event.target.value);
                this.optionValueTitles[index] = optionSelected && optionSelected.product_option_value_title;
            },
            changeSelected() {
                let selected = false;
                for(let i = 0; i < this.optionsAll.length; i++){
                    selected = false
                    for(let n = 0; n < this.optionsAll[i].product_option_values.length; n++){
                        if(this.selectedOptionValues.includes(this.optionsAll[i].product_option_values[n].product_option_value_id)) {
                            selected = this.optionsAll[i].product_option_values[n].product_option_value_id
                            this.optionValueTitles[i] = this.optionsAll[i].product_option_values[n].product_option_value_title;
                        }
                    }
                    if(selected) {
                        this.optionValues[i] = selected

                    } else {
                    this.optionValues[i] = null; 
                    }
                }
            }
        },
        watch: {
            sendOptions: function () {
                if (this.sendOptions) {
                    let optionIds = [];
                    for(let i = 0; i < this.optionsAll.length; i++){
                        for(let n = 0; n < this.optionsAll[i].product_option_values.length; n++){
                            optionIds.push(this.optionsAll[i].product_option_values[n].product_option_value_id)
                        }
                    }
                    // prevent duplicates in selected array
                    this.$parent.$emit('removeOptions', optionIds)
                    this.$parent.$emit('optionsSending', this.optionValues.filter(function(n){ return n != null }), true);
                }
            },
            optionsAll: {
                handler: "changeSelected",
                immediate: true
            }
        },
        created(){
            if(this.optionsSelected) {
                this.selectedOptionValues = this.optionsSelected;
                this.changeSelected();
            }
        }
    }
</script>